export const services = [
  {
    icon: "ri-broadcast-line",
    title: "Wholesale Voice Termination",
    desc: "A/Z destinations with premium and standard route options. Post-paid and pre-paid billing, real-time CDRs, and LCR-friendly routing.",
    to: "/solutions/wholesale-voice-termination",
    tag: "Core route",
  },
  {
    icon: "ri-server-line",
    title: "For VoIP Operators",
    desc: "Interconnect with a redundant SBC layer, private VLANs, and volume-based commercial terms tuned for carrier traffic profiles.",
    to: "/solutions/voip-operators",
    tag: "Carrier grade",
  },
  {
    icon: "ri-headphone-line",
    title: "Call Centers & CPaaS",
    desc: "Answer-seizure-ratio and post-dial-delay optimized routes for outbound dialers, contact centers, and programmable-voice APIs.",
    to: "/solutions/call-centers-cpaas",
    tag: "Dialer-ready",
  },
];

export const advantages = [
  {
    icon: "ri-shield-check-line",
    title: "Direct interconnections",
    desc: "Tier-1 and Tier-2 partnerships in North America, LATAM, Europe, MENA, APAC and Africa — fewer hops, cleaner audio.",
  },
  {
    icon: "ri-line-chart-line",
    title: "Verified quality KPIs",
    desc: "ASR, ACD and PDD monitored per destination in real time. Route swaps happen automatically when thresholds drop.",
  },
  {
    icon: "ri-flashlight-line",
    title: "Rapid onboarding",
    desc: "From NDA to first test call in as little as 48 hours. Pre-configured SBC templates for FreeSWITCH, Asterisk, Kamailio.",
  },
  {
    icon: "ri-price-tag-3-line",
    title: "Transparent pricing",
    desc: "No hidden connection fees or minimum commitments. Custom LCR quotes within one business day.",
  },
  {
    icon: "ri-customer-service-2-line",
    title: "24/7 human NOC",
    desc: "Not a bot — a real network operations team on Telegram, WhatsApp, email or ticket, following the sun.",
  },
  {
    icon: "ri-lock-2-line",
    title: "Anti-fraud protection",
    desc: "Automated CLI screening, destination velocity limits, and revenue-share fraud detection built into the platform.",
  },
];

export const regions = [
  { name: "North America", codes: "+1", destinations: 480, icon: "ri-map-pin-2-line" },
  { name: "Latin America", codes: "+52 · +55 · +54", destinations: 640, icon: "ri-map-pin-2-line" },
  { name: "Europe", codes: "+44 · +49 · +33", destinations: 920, icon: "ri-map-pin-2-line" },
  { name: "MENA", codes: "+971 · +966 · +20", destinations: 310, icon: "ri-map-pin-2-line" },
  { name: "Asia Pacific", codes: "+91 · +62 · +63", destinations: 780, icon: "ri-map-pin-2-line" },
  { name: "Africa", codes: "+234 · +27 · +254", destinations: 420, icon: "ri-map-pin-2-line" },
];

export const useCases = [
  {
    tag: "Pricing",
    title: "Flexible Pricing",
    desc: "Competitive rates with accurate pre-paid and post-paid billing — no hidden fees or minimum commitments.",
    icon: "ri-price-tag-3-line",
  },
  {
    tag: "Quality",
    title: "Premium CLI Routes",
    desc: "Guaranteed performance backed by daily testing and a proprietary, cutting-edge quality control system.",
    icon: "ri-award-line",
  },
  {
    tag: "Security",
    title: "Automated Fraud Blocking",
    desc: "Proactively blocks fraudulent calls and SMS in real time, stopping threats before they cause financial loss.",
    icon: "ri-shield-flash-line",
  },
  {
    tag: "Protection",
    title: "Real-time Detection",
    desc: "Signaling-layer protection detects telecom fraud instantly with granular, targeted blocking to neutralize threats.",
    icon: "ri-radar-line",
  },
];

export const steps = [
  { n: "01", title: "Discovery call", desc: "Share your traffic profile, destinations, and quality expectations." },
  { n: "02", title: "Custom LCR quote", desc: "You get a targeted rate deck matched to your top destinations within 24h." },
  { n: "03", title: "Technical setup", desc: "IP authentication, codec profile, SBC configuration and test calls." },
  { n: "04", title: "Go live", desc: "Full production with real-time CDRs, portal access, and dedicated account manager." },
];

export const testimonials = [
  {
    quote: "Voxmaster took over our LATAM termination and lifted ASR on Mexico Mobile by nine points in the first month. Their team actually cares.",
    name: "Diego Alarcón",
    role: "Head of Carrier Relations",
    company: "Vozeo Telecom",
    avatarSeed: "diego-avatar-01",
  },
  {
    quote: "We ported 12,000 US DIDs to Voxmaster over a weekend without a single dropped inbound. Portal and API are clean, docs are clean.",
    name: "Melissa Chen",
    role: "VP of Operations",
    company: "BrightBridge CPaaS",
    avatarSeed: "melissa-avatar-02",
  },
  {
    quote: "Transparent pricing, no games with LCR ordering. If a premium route degrades they flag it before we do.",
    name: "Ahmed Farouq",
    role: "CTO",
    company: "Nileline Communications",
    avatarSeed: "ahmed-avatar-03",
  },
];

export const trustLogos = [
  {
    name: "Tata Communications",
    src: "https://storage.helloreaddy.io/project_files/8c4f1836-6d16-4bc3-b7aa-3e199a3363f1/16ef255c-4e21-4763-ba06-8c8a83fa1bbc_Tata-Communications-Logo-White.svg",
    isWhite: true,
  },
  {
    name: "HAYO Telecom",
    src: "https://storage.helloreaddy.io/project_files/8c4f1836-6d16-4bc3-b7aa-3e199a3363f1/68bb17c9-f4a0-456a-9b2e-04bd81e94a88_compressed_hayo_telecom_logo.webp",
  },
  {
    name: "Lensols.com",
    src: "https://storage.helloreaddy.io/project_files/8c4f1836-6d16-4bc3-b7aa-3e199a3363f1/a30f5306-03d6-4864-99e1-8b52bc0ed40c_lensolslogo.gif",
  },
  {
    name: "Voxbridge.com",
    src: "https://storage.helloreaddy.io/project_files/8c4f1836-6d16-4bc3-b7aa-3e199a3363f1/d0891183-3bec-4ebb-9b39-839110710d17_compressed_Logo-Voxbridge.webp",
  },
  {
    name: "IDT",
    src: "https://storage.helloreaddy.io/project_files/8c4f1836-6d16-4bc3-b7aa-3e199a3363f1/f824da1a-fa20-40b8-9bf0-83eab49a4d4f_IDTlogo_idt.svg",
  },
  {
    name: "BICS",
    src: "https://storage.helloreaddy.io/project_files/8c4f1836-6d16-4bc3-b7aa-3e199a3363f1/215de77f-bda1-4ef1-92f8-d9226e62a677_compressed_bics-logo.webp",
  },
  {
    name: "airtel",
    src: "https://storage.helloreaddy.io/project_files/8c4f1836-6d16-4bc3-b7aa-3e199a3363f1/eb1b7c32-21a6-450c-89e2-91b918ddaa5b_compressed_Airtel_India-Logo.wine.webp",
  },
  {
    name: "Sky infocom",
    src: "https://storage.helloreaddy.io/project_files/8c4f1836-6d16-4bc3-b7aa-3e199a3363f1/bb1ddf63-e63b-4b7d-b31f-0237eb5427df_compressed_SkyInfocom.Logo.webp",
  },
  {
    name: "Ukrtelecom",
    src: "https://storage.helloreaddy.io/project_files/8c4f1836-6d16-4bc3-b7aa-3e199a3363f1/1de5e75d-79dc-4ef9-bbf4-e1b4f0096c5b_ukrtelecomlogo.svg",
  },
  {
    name: "Ideatelecom.com",
    src: "https://storage.helloreaddy.io/project_files/8c4f1836-6d16-4bc3-b7aa-3e199a3363f1/9291b558-4f8d-458d-9344-f94ccebcbf7c_compressed_IDeaTelecom.webp",
  },
  {
    name: "Vazq",
    src: "https://storage.helloreaddy.io/project_files/8c4f1836-6d16-4bc3-b7aa-3e199a3363f1/fcdd4a41-92e8-4c38-94c8-a05e59650f86_compressed_Vazq_logo1.webp",
  },
  {
    name: "4seasonsrecovery.com",
    src: "https://storage.helloreaddy.io/project_files/8c4f1836-6d16-4bc3-b7aa-3e199a3363f1/e043d11d-70b7-4922-997f-2c761c2e8b54_compressed_4seasonsdetox-logo.webp",
    isWhite: true,
  },
];

export const stats = [
  { value: "60M+", label: "Minutes routed / year" },
  { value: "700+", label: "Interconnects worldwide" },
  { value: "99.99%", label: "Platform uptime SLA" },
  { value: "<45ms", label: "Median PDD, US traffic" },
];